import type { ContractStatus, ContractType } from '../../types/api';

export interface StatusBadge {
  label: string;
  color: string;
}

const STATUS_BADGES: Record<ContractStatus, StatusBadge> = {
  draft: { label: 'Draft', color: 'gray' },
  active: { label: 'Active', color: 'pine' },
  in_renewal: { label: 'In renewal', color: 'yellow' },
  expired: { label: 'Expired', color: 'orange' },
  terminated: { label: 'Terminated', color: 'red' },
};

const TYPE_LABELS: Record<ContractType, string> = {
  row: 'ROW',
};

export function formatContractStatus(status: ContractStatus): StatusBadge {
  return STATUS_BADGES[status] ?? { label: status, color: 'gray' };
}

export function formatContractType(type: ContractType): string {
  return TYPE_LABELS[type] ?? String(type);
}

/**
 * Returns true when expiration_date falls on or before `today + windowDays`.
 * Perpetual contracts (NULL expiration) and already-expired ones are excluded.
 */
export function isExpiringSoon(
  expirationDate: string | null,
  today: Date,
  windowDays: number,
): boolean {
  if (!expirationDate) return false;
  const exp = new Date(`${expirationDate}T00:00:00Z`);
  if (Number.isNaN(exp.getTime())) return false;
  const cutoff = new Date(today);
  cutoff.setUTCDate(cutoff.getUTCDate() + windowDays);
  return exp <= cutoff && exp >= today;
}

export function dateToYmd(d: Date): string {
  const yyyy = d.getUTCFullYear();
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
